import { useState } from "react";

/** Navigation state for a chat this page just created (e.g. so an attached file has somewhere to go). */
export const CREATED_CHAT = { createdChat: true } as const;

export function isCreatedChat(state: unknown): boolean {
  return typeof state === "object" && state !== null && (state as { createdChat?: unknown }).createdChat === true;
}

/**
 * Changes when the user moves to another chat. A new chat getting its id isn't
 * a move when this page created it (`created`): attaching a file to a new chat
 * creates it and changes the URL, and that's still the same chat.
 */
export function useChatSwitchKey(sessionUuid: string | undefined, created: boolean): number {
  const [seen, setSeen] = useState({ uuid: sessionUuid, key: 0 });
  if (seen.uuid !== sessionUuid) {
    const sameChat = seen.uuid === undefined && created;
    setSeen({ uuid: sessionUuid, key: sameChat ? seen.key : seen.key + 1 });
  }
  return seen.key;
}
